import { render, staticRenderFns } from "./canvasPanel.vue?vue&type=template&id=5d0bc8a8&scoped=true&"
import script from "./canvasPanel.vue?vue&type=script&lang=js&"
export * from "./canvasPanel.vue?vue&type=script&lang=js&"
import style0 from "./canvasPanel.vue?vue&type=style&index=0&id=5d0bc8a8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0bc8a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d0bc8a8')) {
      api.createRecord('5d0bc8a8', component.options)
    } else {
      api.reload('5d0bc8a8', component.options)
    }
    module.hot.accept("./canvasPanel.vue?vue&type=template&id=5d0bc8a8&scoped=true&", function () {
      api.rerender('5d0bc8a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvasPanel.vue"
export default component.exports